import { ErrorViewerComponent } from './error-viewer/error-viewer.component';
import { remoteControlGuard } from './../core/guards/remote-control.guard';
import { authGuard } from './../core/guards/auth.guard';
import { DefaultViewerComponent } from './default-viewer/default-viewer.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { REMOTE_KEY_SETS } from './../core/services/remote-control.service';
import { ImageViewerContainerComponent } from './image-viewer-container/image-viewer-container.component';
import { VideoViewerContainerComponent } from './video-viewer-container/video-viewer-container.component';
import {ImageCarouselContainerComponent} from './image-carousel-container/image-carousel-container.component';
import {DatetimeViewerContainerComponent} from './datetime-viewer-container/datetime-viewer-container.component';
import {SmartAppMessageViewerComponent} from './smart-app-message-viewer/smart-app-message-viewer.component';

const routes: Routes = [
  {
    path: 'default/:messageRecipientId/:messageId',
    component: DefaultViewerComponent,
    canActivate: [authGuard, remoteControlGuard],
    data: { keySet: REMOTE_KEY_SETS.ok_arrows_back_colours },
  },
  {
    path: 'default-smartapp/:messageRecipientId/:messageId',
    component: SmartAppMessageViewerComponent,
    canActivate: [authGuard, remoteControlGuard],
    data: { keySet: REMOTE_KEY_SETS.ok_arrows_back_colours },
  },
  {
    path: 'image-viewer/:messageRecipientId/:messageId',
    component: ImageViewerContainerComponent,
    canActivate: [authGuard, remoteControlGuard],
    data: { keySet: REMOTE_KEY_SETS.ok_arrows_back },
  },
  {
    path: 'video-viewer/:messageRecipientId/:messageId',
    component: VideoViewerContainerComponent,
    canActivate: [authGuard, remoteControlGuard],
    data: { keySet: REMOTE_KEY_SETS.ok_arrows_back_colours },
  },
  {
    path: 'error/:errorTitle/:errorMessage/:buttonText',
    component: ErrorViewerComponent,
    canActivate: [authGuard, remoteControlGuard],
    data: { keySet: REMOTE_KEY_SETS.ok_arrows },
  },
  {
    path: 'image-carousel-viewer',
    component: ImageCarouselContainerComponent,
    canActivate: [authGuard, remoteControlGuard],
    data: { keySet: REMOTE_KEY_SETS.ok_arrows_back_colours },
  },
  {
    path: 'datetime-viewer',
    component: DatetimeViewerContainerComponent,
    canActivate: [authGuard, remoteControlGuard],
    data: { keySet: REMOTE_KEY_SETS.ok_arrows_back_colours },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ViewersRoutingModule {}
